// extracted by mini-css-extract-plugin
export default {"itemWrapper":"styles_itemWrapper__a8aKe","title":"styles_title__0ho4s","price":"styles_price__tl982"};